import React from 'react';
import { Inbox } from 'lucide-react';

interface EmptyStateProps {
  title: string;
  description: string;
  ctaLabel?: string;
  onCta?: () => void;
  icon?: React.ComponentType<{ size?: number; className?: string }>;
}

export const EmptyState: React.FC<EmptyStateProps> = ({
  title,
  description,
  ctaLabel,
  onCta,
  icon: Icon = Inbox,
}) => {
  return (
    <div className="rounded border border-slate-200 dark:border-zinc-800 bg-slate-50/50 dark:bg-zinc-900/60 shadow-sm p-[var(--card-padding)] min-h-[360px] flex items-center justify-center text-center">
      <div className="max-w-xl">
        <div className="mx-auto w-16 h-16 rounded bg-slate-100 dark:bg-zinc-800 border border-slate-200 dark:border-zinc-700 flex items-center justify-center text-slate-500 dark:text-zinc-300">
          <Icon size={28} />
        </div>
        <h3 className="mt-5 text-xl font-semibold tracking-tight text-slate-900 dark:text-zinc-100">{title}</h3>
        <p className="mt-2 text-sm text-slate-600 dark:text-zinc-400">{description}</p>
        {ctaLabel && onCta && (
          <button
            type="button"
            onClick={onCta}
            className="mt-6 h-11 px-6 rounded bg-blue-600 hover:bg-blue-700 text-white text-sm font-semibold shadow-sm transition-colors"
          >
            {ctaLabel}
          </button>
        )}
      </div>
    </div>
  );
};
